export default __webpack_public_path__ + "img/Montserrat-Bold_4b33f3d.eot";